import styled from 'styled-components';
import { MenuMixin } from '../../mixins/components/MenuMixin';
import { Dropdown } from '../Dropdown/Dropdown';
export var StyledMenu = /*#__PURE__*/styled(Dropdown).withConfig({
  displayName: "StyledMenu",
  componentId: "c11n-8-111-1__sc-4596tk-0"
})(["", ""], MenuMixin);